export default __webpack_public_path__ + "static/media/isr_flag.783bae03.jpg";